module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-MediumItalic.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-MediumItalic.woff
// module id = 81
// module chunks = 8